// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"f9c08634","137":"6d0a7afc","233":"d15a2910","241":"b19cc7fd","481":"d97e47f3","518":"255c7a94","657":"3947b04c","658":"a631d9ba","670":"bb82e86c","741":"db64d594","822":"f8e325f5","858":"5cdeb0b4","865":"7b46b61e","900":"1e082efc"}[chunkId] + ".chunk.js";
};